import { Box, Typography, useTheme } from '@mui/material'
import { FlexBox } from 'components/atoms'
import {
    BetTypeSelector,
    OperatorSelector,
    RaceSelector
} from 'components/molecules'
import { useBetContext } from 'contexts/BetContext'
import { useTranslation } from 'contexts/TranslationContext'

export const HeaderSection = () => {
    const theme = useTheme()
    const { upcomingEvents, selectedOperator, race } = useBetContext()
    const translation = useTranslation()

    return (
        <>
            <FlexBox
                sx={{
                    width: '100%',
                    position: 'fixed',
                    top: 0,
                    backgroundColor: 'white',
                    py: 1,
                    zIndex: 2
                }}
            >
                <Typography
                    variant="title-16-bold"
                    sx={{
                        fontSize: 20,
                        mt: 2,
                        pl: 2,
                        color: theme.palette.text.secondary
                    }}
                >
                    {translation.prepareBet}
                    {race ? ` (R${race?.cNumber}C${race?.nb})` : ''}
                </Typography>
            </FlexBox>

            <Box sx={{ mt: 8, mb: 1 }}>
                <OperatorSelector />
            </Box>

            {upcomingEvents.length ? (
                <Box sx={{ m: 2, width: 'fill-available' }}>
                    <RaceSelector>
                        <BetTypeSelector
                            operator={selectedOperator}
                            sx={{ px: 1, pt: 1.75, mt: 2 }}
                        />
                    </RaceSelector>
                </Box>
            ) : (
                <Box sx={{ mt: 2 }}>
                    <BetTypeSelector operator={selectedOperator} />
                </Box>
            )}
        </>
    )
}
